import React from 'react';

type StatusType = 'joined' | 'pending' | 'not_joined';

interface Props {
  status: StatusType;
  children?: React.ReactNode;
  className?: string;
}

const mapStyles: Record<StatusType, string> = {
  joined: 'bg-rose-100 text-rose-700',
  pending: 'bg-amber-100 text-amber-700',
  not_joined: 'bg-slate-100 text-slate-600'
};

export const StatusPill: React.FC<Props> = ({ status, children, className = '' }) => {
  return (
    <span className={`px-2 py-0.5 text-xs rounded-full font-semibold whitespace-nowrap ${mapStyles[status]} ${className}`}>
      {children}
    </span>
  );
};

export default StatusPill;


